import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceRequestBody } from "@vendata/power-up-spec";

export const useCreateOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: PowerUpServiceRequestBody["createOrganization"],
    ) => {
      return handleClientMethod(
        getClient().POST("/organization", { body: data }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organization"] });
    },
  });
};
